import { useVariants } from 'modules/productDetail'
import React from 'react'
import { ProductAttributes, SizeAttribute } from '../types'

export default function useSizeChart(
  sizeChartKey,
  expectedSizeChartAttributes
) {
  const variants = useVariants()

  return React.useMemo(() => {
    if (!variants.data.length) return []

    const sizeList: Record<number, ProductAttributes> = {}
    for (let i = 0; i < variants.data.length; i++) {
      const sizeChartDataEntry = variants.data[i].sizeChartData

      if (!sizeChartDataEntry) {
        continue
      }

      const clothingSize = sizeChartDataEntry.sizeChartClothingsize || '0'
      const sizeChartAttributes = sizeChartDataEntry.sizeChartAttributes

      if (sizeChartAttributes) {
        const sizeAttributes: SizeAttribute[] = []

        // Iterate over all expected attributes and add them to the sizeAttributes array.
        for (const kv of expectedSizeChartAttributes) {
          const key = kv[0]
          const expectedAttribute = kv[1]
          const attribute = sizeChartAttributes[key]

          if (attribute) {
            sizeAttributes.push({
              label: attribute.label,
              value: attribute.value,
              unit: attribute.unit,
              sort: attribute.sorting
            })
          } else {
            sizeAttributes.push({
              label: expectedAttribute.label,
              value: -1,
              unit: expectedAttribute.unit,
              sort: expectedAttribute.sorting
            })
          }
        }

        sizeAttributes.sort((a, b) => {
          return a.sort - b.sort
        })

        sizeList[clothingSize] = {
          size: sizeChartDataEntry.sizeChartClothingsize ?? null,
          sizeAttributes: sizeAttributes,
          sort: sizeChartDataEntry?.sizeChartClothingsizeSorting ?? null
        }
      }
    }
    return Object.values(sizeList).sort((a, b) => a.sort - b.sort)
  }, [variants, sizeChartKey])
}
